import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';
import {convertFromRaw} from 'draft-js'
import { stateToHTML } from 'draft-js-export-html';

import '../styles/blog-page.css';
import { getBlog } from '../services/API/BlogpostAPI';
import {SimpleEditor} from "../components/tiptap-templates/simple/simple-editor";

const BlogPage = () => {
  const { blogId } = useParams();
  const [blogpost, setBlogpost] = useState(null) 

  useEffect(() => {
    const fetchData = async () => {
      let data = await getBlog(blogId);
      setBlogpost(data);
    }
    fetchData();
  }, [blogId])

  return (
    blogpost ? 
      <div>
        <TitleScreen
          date={blogpost.date}
          country={blogpost.country}
          title={blogpost.title}
          mainImage={blogpost.mainImage.path}
        />
        <BlogTextScreen content={blogpost.content} />
      </div>
    : <></>
  )
}

const API_URL = process.env.REACT_APP_API_ENDPOINT;

const TitleScreen = ({title, date, country, mainImage}) => {
  return (
    <div className='blog-page__background-image' style={{backgroundImage: `url(${API_URL}/Assets/${mainImage})`}}>
      <div className='blog-page__background-black'/>
      <div className='blog-page__background-container'>
          <div className='blog-page__title-container'>
              <span className='blog-page__date-separator-country text'>{date} | {country}</span>
              <h1 className='title blog-page__title'>{title}</h1>
          </div>
      </div>
    </div>
  )  
}

const BlogTextScreen = ({content}) => {
  const contentAsJson = JSON.parse(content);
  console.log(contentAsJson);
  
  return (
    <div className='blog-page__blog-text-container'>
      <div className='blog-page__blog-text-text-container text'>
        <SimpleEditor editable={false} content={contentAsJson} />
      </div>   
    </div>
  )
}

export default BlogPage
